var map = {
	"./Component 2 – 1.png": 8062,
	"./Group 1580.png": 4726,
	"./Group 1582.png": 872,
	"./Group 1583.png": 1478,
	"./Group 1584.png": 1810,
	"./Group 943.png": 102,
	"./Hamburger_icon.svg.png": 8872,
	"./Hero_big_img.png": 5505,
	"./Hero_big_img.svg": 4685,
	"./adnroid_studio.png": 6964,
	"./bacground_hero_2.png": 498,
	"./call_img.png": 5427,
	"./contact_hero_img.png": 2986,
	"./css_icon.png": 1931,
	"./dex-synthetic.png": 8888,
	"./dots_hero.png": 7604,
	"./down_icon.png": 6387,
	"./dropdown.png": 5040,
	"./fira_base_icon.png": 2037,
	"./hero_mini_bacground.svg": 2949,
	"./icon_developer.png": 5887,
	"./icon_facebook.png": 6895,
	"./icon_in.png": 9606,
	"./icon_intagram.png": 8666,
	"./icon_javascript.png": 1368,
	"./icon_location.png": 3507,
	"./icon_message.png": 6788,
	"./icon_tell.png": 9561,
	"./icon_twich.png": 251,
	"./icon_youttube.png": 8476,
	"./images_work_line/Group 1574.png": 1993,
	"./images_work_line/Group 1585.png": 8353,
	"./images_work_line/Group 1586.png": 8326,
	"./images_work_line/Group 1587.png": 6946,
	"./images_work_line/Group 1588.png": 2100,
	"./images_work_line/Group 1589.png": 3965,
	"./images_work_line/Path 7110.png": 6366,
	"./images_work_line/work_line_fast.png": 5125,
	"./images_work_line/work_list_office.png": 5297,
	"./images_work_line/work_list_plan.png": 7095,
	"./images_work_line/work_list_testing.png": 7828,
	"./images_work_line/work_main_bacground.png": 2960,
	"./img_bacground_1.png": 811,
	"./img_bacground_2.png": 93,
	"./img_bacground_3.png": 6832,
	"./img_bacground_4.png": 531,
	"./img_group.png": 9262,
	"./img_idea.png": 1080,
	"./img_post.png": 6656,
	"./img_servis_code.svg": 3829,
	"./img_servis_mobile.svg": 3344,
	"./img_users.png": 4164,
	"./in_icon.png": 2028,
	"./ios_icon.png": 3180,
	"./java-icon.png": 1788,
	"./javascript_icon.png": 5247,
	"./location_icon_contact.png": 3450,
	"./logo.png": 4427,
	"./logo.svg": 2835,
	"./message_icon_contact.png": 554,
	"./my_sql_icon.png": 4875,
	"./new_img.svg": 5287,
	"./portafilo_hero_img.png": 9834,
	"./python_icon.png": 739,
	"./react-icon.png": 5248,
	"./ruby_icon.png": 4663,
	"./selectDownImg.png": 8010,
	"./serveis_img_fast.svg": 5507,
	"./serveis_img_smm.svg": 5146,
	"./services_main_img.svg": 4768,
	"./servies_Hero_img.png": 7450,
	"./servis_bacground.png": 5823,
	"./servis_img_desing.svg": 7227,
	"./servis_img_user.svg": 2338,
	"./site_icon.svg": 665,
	"./spec_11.png": 2049,
	"./spec_17_icon.png": 9016,
	"./spec_19_icon.png": 4215,
	"./spec_3.png": 4235,
	"./spec_7.png": 2384,
	"./tell_icon_contact.png": 8019,
	"./texnology_img1.png": 9414,
	"./texnology_img10.png": 5293,
	"./texnology_img11.png": 4812,
	"./texnology_img12.png": 9357,
	"./texnology_img13.png": 9375,
	"./texnology_img2.png": 90,
	"./texnology_img3.png": 563,
	"./texnology_img4.png": 9429,
	"./texnology_img5.png": 7812,
	"./texnology_img6.png": 8955,
	"./texnology_img7.png": 1865,
	"./texnology_img8.png": 2846,
	"./texnology_img9.png": 8929,
	"./trello_icon.png": 4255,
	"./user_photo.png": 4350,
	"./vergul_icon.png": 5025,
	"./windowImage.png": 8048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;